import { CORE_AXIOS, type Http } from '@/core'
import { container } from 'tsyringe'
import baseAxios from "axios"
// 查询order
export const fetchOrder = async (data?: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get('/v1/api/oms/order', data)
}
// 修改订单详情
export const updateOrder = async (key: number, data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.put(`/v1/api/oms/order/${key}`, data)
}
export const cancelOrder = async (key: number): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.put(`/v1/api/oms/order/status/${key}`)
}
// 查询支付宝支付是否成功
export const queryAlipay = async (data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get('/v1/api/oms/alipay/query', data)
}
// 查询wx支付是否成功
export const queryWxpay = async (data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get('/v1/api/oms/wxpay/query', data)
}
// wx支付
export const wxpay = async (data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get('/v1/api/oms/wxpay', data)
}
// 支付宝支付
export const alipay = async (data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get('/v1/api/oms/alipay', data)
}
// 查询快递物流
export const queryExpress = async (data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get('/v1/api/oms/express/logistics', data)
}
// 商品详情
export const fetchCustomSpu = async (key: string): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/pms/custom/spus/${key}`)
}
// 查询单个order
export const getOrderDetail = async (id?: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/oms/order/${id}`)
}

// 查询评价
export const fetchComment = async (data?: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/comment`, data)
}
// 查询订单和评价
export const fetchOrderComment = async (id: number, data?: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/oms/order/${id}/comment`, data)
}

export const refundOrder = async (id: number): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.post(`/v1/api/oms/direct/refund/${id}`)
}


export const refundCreate = async (id: number, data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.post(`/v1/api/oms/order/${id}/refund`, data)
}

export const refundDelete = async (id: number): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.delete(`/v1/api/oms/order/refund/${id}`)
}

export const fetchOrderStatus = async (): Promise<any> => {
  return await baseAxios.get('/admin/v1/api/dictionaries/orderStatus')
}